<template>
	<div>
		<div class="hidden-xs-only">
			<div class="h-600">
				<img :src="info.header_info.bg_image" mode="widthFix" class="width-100 h-600" />
				<div class="fu wow bounceInDown" data-wow-duration="2s" data-wow-delay="0s" data-wow-offset="10"
					data-wow-iteration="1">
					<div class="d-flex-center f-57 c-white font-weight-bold">
						{{info.header_info.bg_title}}
					</div>
					<div class="d-flex-center">
						<div class="f-28 c-white m-t-20 t-c width-20 lh-40">
							{{info.header_info.bg_content}}
						</div>
					</div>
				</div>
			</div>

			<div class="d-flex-center width-100 h-70 bgc-white b-b">
				<div class="width-20 d-flex-between" id="tab">
					<div @click="choice(index)" v-for="(item,index) in tab" :key="index">
						<div :class="nav==index? 'c-EA4638':''" class="h-66 d-flex-items-center font-weight-bold f-18">
							{{item}}
						</div>
						<div :class="nav==index? 'h-4 bgc-EA4638':''"></div>
					</div>
				</div>
			</div>

			<div class="bgc-f4f4f4 d-flex-center">
				<div class="width-80 d-flex-row p-t-100">
					<div class="width-50 wow bounceInLeft" data-wow-duration="2s" data-wow-delay="0s"
						data-wow-offset="10" data-wow-iteration="1">
						<div class="f-30 c-00 font-weight-bold m-t-20">润寓概况</div>
						<div class="m-t-35 width-90 f-14 c-33 lh-20">
							{{info.header_info.content}}
							<!-- 长春市人才公寓项目是长春市委、市政府为了贯彻国家“大众创新、万众创业”的决策部署，深入实施“人才强市”战略，优化人才创新创业发展环境，发挥住房在吸引和集聚人才方面积极作用而推出政府实事工程。项目已列入2017年“建设幸福长春”行动计划，并作为百件惠民实事之一重点推进。2017年11月，长春市出台了“人才新政20条”以及招才引智的“万人计划”，人才公寓项目被列为其中重要保障服务内容。 -->
							<!-- 	<br />
							<br /> -->
							<!-- 长春市人才公寓项目主要是为到长工作、创业，且在本市暂无住房的大学毕业生及其他高层次人才，提供价低质优的周转性住房，租金仅为市场价的70%。项目按照“政府主导、企业实施、市场运作、智慧管理”的运营模式，分期分批推进，以全新的租住理念，实现“线上选房、线上审批、线上缴费、拎包入住”的便捷租住体验。 -->
						</div>
						<div class="f-30 c-00 font-weight-bold m-t-40">建设规模</div>
					</div>
					<div class="width-50 d-flex-center wow bounceInRight" data-wow-duration="2s" data-wow-delay="0s"
						data-wow-offset="10" data-wow-iteration="1">
						<video id="video" :src="info.header_info.video_file" controls="true"
							poster="../../assets/image/index/vi.png" preload="auto" webkit-playsinline="true"
							playsinline="true" x-webkit-airplay="allow" x5-video-player-type="h5"
							x5-video-player-fullscreen="true" x5-video-orientation="portraint" style="object-fit:fill"
							class="width-90 h-400">
						</video>
					</div>
				</div>
			</div>

			<div class="bgc-f4f4f4 d-flex-center p-b-100">
				<div class="h-140 bgc-white width-80 m-t-50 d-flex-items-center">
					<div class="width-25 h-80 b-r">
						<div class="d-flex-center d-flex-items-center">
							<span class="f-30 c-EA4638 font-weight-bold">
								<countTo :startVal='0' :endVal='info.header_info.community_num' :duration='5000'>
								</countTo>
							</span>
							<span class="f-16 c-00">/个</span>
						</div>
						<div class="f-16 c-00 d-flex-center m-t-20">
							小区分布
						</div>
					</div>
					<div class="width-25 h-80 b-r">
						<div class="d-flex-center d-flex-items-center">
							<span class="f-30 c-EA4638 font-weight-bold">
								<countTo :startVal='0' :endVal='areas' :duration='5000'></countTo>
								~
								<countTo :startVal='0' :endVal='areae' :duration='5000'></countTo>
							</span>
							<span class="f-16 c-00">/平方米</span>
						</div>
						<div class="f-16 c-00 d-flex-center m-t-20">
							房屋面积区
						</div>
					</div>
					<div class="width-25 h-80 b-r">
						<div class="d-flex-center d-flex-items-center">
							<span class="f-30 c-EA4638 font-weight-bold">
								<countTo :startVal='0' :endVal='info.header_info.house_num' :duration='5000'></countTo>
							</span>
							<span class="f-16 c-00">/套</span>
						</div>
						<div class="f-16 c-00 d-flex-center m-t-20">
							一期建设
						</div>
					</div>
					<div class="width-25 h-80">
						<div class="d-flex-center d-flex-items-center">
							<span class="f-30 c-EA4638 font-weight-bold">
								<countTo :startVal='0' :endVal='info.header_info.people_num' :duration='5000'></countTo>
							</span>
							<span class="f-16 c-00">/人</span>
						</div>
						<div class="f-16 c-00 d-flex-center m-t-20">
							可容纳
						</div>
					</div>
				</div>
			</div>

			<div class="w-100p p-t-100 p-b-100 bgc-white">
				<div class="f-30 c-00 font-weight-bold m-t-20 d-flex-center">公寓优势</div>
				<div class="d-flex-center">
					<div class="m-t-30 d-flex-center w-80p">
						<div @mouseenter="mouseenter(index)" @mouseleave="mouseleave" v-for="(item,index) in advantage"
							:key="index" class="w-20p m-l-10 m-r-10">
							<img :src="item.smallimages" class="w-100p h-385" />
							<div v-if="lnav!=index" class="fu1 w-100p h-385 d-flex-items-center d-flex-column">
								<div class="d-flex-center f-20 c-white m-t-150">{{item.title0}}</div>
								<div class="d-flex-center f-20 c-white m-t-20">{{item.title1}}</div>
								<div class="d-flex-center w-30 h-7 bgc-EA4638 m-t-20"></div>
							</div>
							<div v-else class="fu1 c-white w-100p h-385 bgc-EA4638 p-t-40 p-l-25 p-r-25">
								<div class="f-20 c-white">{{item.title}}</div>
								<div class="d-flex-center w-30 h-7 bgc-white m-t-15"></div>
								<div class="f-14 lh-25 m-t-30">
									{{item.content}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="w-100p p-t-100 p-b-100 bgc-f4f4f4">
				<div class="f-30 c-00 font-weight-bold m-t-20 d-flex-center m-b-60">配套设施服务</div>
				<div v-for="(item,index) in otherinfo.support" :key="index" class="d-flex-center m-b-20">
					<div class="bgc-white w-80p shadow p-50 d-flex-row">
						<div class="w-20p">
							<div class="d-flex-center">
								<img :src="item.smallimages" class="w-55 h-60" />
							</div>
							<div class="d-flex-center m-t-25 f-20 c-00 font-weight-bold">
								{{item.title}}
							</div>
						</div>
						<div class="w-80p lh-40 d-flex-items-center">
							{{item.maincontent}}
						</div>
					</div>
				</div>
			</div>

			<div class="w-100p bgimg p-t-30 p-b-70 c-white">
				<div class="f-30 font-weight-bold d-flex-center">{{otherinfo.prospect.title}}</div>
				<div class="d-flex-center">
					<div class="bgc m-t-60 w-80p h-340 p-100">
						<div class="f-14 lh-35">
							{{otherinfo.prospect.maincontent}}
							<!-- 作为长春市第一个人才公寓项目，长春市人才公寓项目的意义深远，不仅减轻青年人才就业创业成本，实现长春市“吸引人才、留住人才”的目的，更是创新了城市资产经营模式，对放大国有资本功能以及加快国有企业转型升级具有重大的引领作用。 -->
						</div>
						<!-- <div class="f-14 lh-22 m-t-50">
							党的十九大报告中提出“加快建立多主体供给、多渠道保障、租购并举的住房制度，让全体人民住有所居”。在中央全新政策的指引下，在房地产行业的拐点契机，未来，长租公寓行业面临巨大的发展前景，项目今后将采取资本运作、引入混合经济等方式，进行自主开发建设或收购兼并房源，实现扩张，发挥优势，依托智慧化信息技术，提升市场份额，实现项目的做大、做强、做优。
						</div> -->
					</div>
				</div>
			</div>

			<div id="condition" class="w-100p p-t-40 p-b-60 c-white bgc-F4F4F4 c-00">
				<div class="f-30 font-weight-bold d-flex-center">{{otherinfo.condition.title}}</div>
				<div class="d-flex-center">
					<div class="f-14 c-00 m-b-50 d-flex-center m-t-30 w-80p">
						{{otherinfo.condition.maincontent}}
						<!-- 按照《长春市人才公寓建设和使用管理办法》中的规定，入住长春市人才公寓需要符合有关审核标准和入住条件，经长春市人社部门审核通过后方可入住，具体条件如下： -->
					</div>
				</div>
				<div class="d-flex-center">
					<div
						class="p-30 d-flex-items-center f-14 lh-40 c-00 d-flex-center m-t-30 w-80p bgc-white b-all h-145">
						{{otherinfo.condition.maincontent2}}
						<!-- 《长春市人才公寓建设和使用管理办法》中规定长春市人才公寓的租赁对象为近3年内从长春市市区外引进到长春市市区企业工作且在市区无住房的高层次人才、产业发展急需紧缺人才，在企业新就业或自主创业的高校毕业生。引进人才除国内外顶尖人才和国家级领军人才外，至少与用人单位签订3年以上（含3年）劳动合同。 -->
					</div>
				</div>
				<div class="d-flex-center m-t-30">
					<div class="w-80p d-flex-between">
						<div @mouseenter="enter(index)" @mouseleave="leave" v-for="(item,index) in otherinfo.personnel"
							:key="index" class="bgc-white b-all width-33" :class="index!=2?'m-r-30':''">
							<div :class="cnav==index? 'w-100p h-6 bgc-EA4638':'h-6'"></div>
							<div class="b-b p-30 m-h-130">
								<div class="d-flex-row d-flex-items-center">
									<div class="b-all-EA4638-3 w-13 h-13 br-60 m-r-10"></div>
									<div class="f-18 c-00">{{item.title}}</div>
								</div>
								<div class="f-14 c-99 lh-30 m-t-15">
									{{item.content}}
								</div>
							</div>
							<div class="p-20">
								<div v-for="(citem,cindex) in item.son_data" :key="cindex" class="d-flex-between lh-40">
									<div class="f-14 c-33">{{citem.title}}</div>
									<div>
										<span class="f-14 c-EA4638">{{citem.content}}</span>
										<span class="f-14 c-66">平方米以上</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="hidden-sm-and-up">
			<div class="h-300">
				<img src="@/assets/image/about/i-1.png" mode="widthFix" class="width-100 h-300" />
				<div class="fufu wow bounceInDown" data-wow-duration="2s" data-wow-delay="0s" data-wow-offset="10"
					data-wow-iteration="1">
					<div class="d-flex-center f-30 c-white font-weight-bold">
						{{info.header_info.bg_title}}
					</div>
					<div class="d-flex-center">
						<div class="f-18 c-white m-t-20 t-c w-65p lh-40">
							{{info.header_info.bg_content}}
						</div>
					</div>
				</div>
			</div>

			<div class="d-flex-center width-100 h-50 bgc-white b-b">
				<div class="width-60 d-flex-between" id="tab">
					<div @click="choice1(index)" v-for="(item,index) in tab" :key="index">
						<div :class="nav==index? 'c-EA4638':''" class="h-46 d-flex-items-center font-weight-bold f-18">
							{{item}}
						</div>
						<div :class="nav==index? 'h-4 bgc-EA4638':''"></div>
					</div>
				</div>
			</div>

			<div class="bgc-f4f4f4">
				<div class="d-flex-center width-100">
					<div class="width-90 wow bounceInLeft p-t-30" data-wow-duration="2s" data-wow-delay="0s"
						data-wow-offset="10" data-wow-iteration="1">
						<div class="f-20 c-00 font-weight-bold m-t-20 d-flex-center">润寓概况</div>
						<div class="m-t-15 width-100 f-12 c-33 lh-20 d-flex-center">
							{{info.header_info.content}}
							<!-- 长春市人才公寓项目是长春市委、市政府为了贯彻国家“大众创新、万众创业”的决策部署，深入实施“人才强市”战略，优化人才创新创业发展环境，发挥住房在吸引和集聚人才方面积极作用而推出政府实事工程。项目已列入2017年“建设幸福长春”行动计划，并作为百件惠民实事之一重点推进。2017年11月，长春市出台了“人才新政20条”以及招才引智的“万人计划”，人才公寓项目被列为其中重要保障服务内容。 -->
							<!-- <br />
							<br /> -->
							<!-- 长春市人才公寓项目主要是为到长工作、创业，且在本市暂无住房的大学毕业生及其他高层次人才，提供价低质优的周转性住房，租金仅为市场价的70%。项目按照“政府主导、企业实施、市场运作、智慧管理”的运营模式，分期分批推进，以全新的租住理念，实现“线上选房、线上审批、线上缴费、拎包入住”的便捷租住体验。 -->
						</div>
					</div>
				</div>
				<div class="d-flex-center width-100 m-t-20">
					<div class="width-90 d-flex-center">
						<video id="video" :src="info.header_info.video_file" controls="true"
							poster="../../assets/image/index/vi.png" preload="auto" webkit-playsinline="true"
							playsinline="true" x-webkit-airplay="allow" x5-video-player-type="h5"
							x5-video-player-fullscreen="true" x5-video-orientation="portraint" style="object-fit:fill"
							class="width-100">
						</video>
					</div>
				</div>
			</div>

			<div class="f-20 c-00 font-weight-bold m-t-20 d-flex-center">建设规模</div>

			<div class="bgc-f4f4f4 d-flex-center p-b-20">
				<div class="h-70 bgc-white width-90 m-t-20 d-flex-items-center">
					<div class="width-50 h-40 b-r">
						<div class="d-flex-center d-flex-items-center">
							<span class="f-15 c-EA4638 font-weight-bold">
								<countTo :startVal='0' :endVal='info.header_info.community_num' :duration='5000'>
								</countTo>
							</span>
							<span class="f-8 c-00">/个</span>
						</div>
						<div class="f-8 c-00 d-flex-center m-t-10">
							小区分布
						</div>
					</div>
					<div class="width-50 h-40">
						<div class="d-flex-center d-flex-items-center">
							<span class="f-15 c-EA4638 font-weight-bold">
								<countTo :startVal='0' :endVal='areas' :duration='5000'></countTo>
								~
								<countTo :startVal='0' :endVal='areae' :duration='5000'></countTo>
							</span>
							<span class="f-8 c-00">/平方米</span>
						</div>
						<div class="f-8 c-00 d-flex-center m-t-10">
							房屋面积区
						</div>
					</div>
				</div>
			</div>
			<div class="bgc-f4f4f4 d-flex-center p-b-20">
				<div class="h-70 bgc-white width-90 d-flex-items-center">
					<div class="width-50 h-40 b-r">
						<div class="d-flex-center d-flex-items-center">
							<span class="f-15 c-EA4638 font-weight-bold">
								<countTo :startVal='0' :endVal='info.header_info.house_num' :duration='5000'></countTo>
							</span>
							<span class="f-8 c-00">/套</span>
						</div>
						<div class="f-8 c-00 d-flex-center m-t-10">
							一期建设
						</div>
					</div>
					<div class="width-50 h-40">
						<div class="d-flex-center d-flex-items-center">
							<span class="f-15 c-EA4638 font-weight-bold">
								<countTo :startVal='0' :endVal='info.header_info.people_num' :duration='5000'></countTo>
							</span>
							<span class="f-8 c-00">/人</span>
						</div>
						<div class="f-8 c-00 d-flex-center m-t-10">
							可容纳
						</div>
					</div>
				</div>
			</div>

			<div class="w-100p p-t-30 p-b-50 bgc-white">
				<div class="f-20 c-00 font-weight-bold d-flex-center">公寓优势</div>
				<div class="d-flex-center m-l-10 m-r-10 h-350" style="overflow-x: scroll;overflow: hidden;">
					<div class="m-t-30 d-flex-row h-350" style="overflow: auto;">
						<div @mouseenter="mouseenter(index)" @mouseleave="mouseleave" v-for="(item,index) in advantage"
							:key="index" class="w-227 m-l-10 m-r-10">
							<img :src="item.smallimages" class="w-227 h-350" />
							<div v-if="lnav!=index" class="fu1 w-227 h-350 d-flex-items-center d-flex-column">
								<div class="d-flex-center f-20 c-white m-t-135">{{item.title0}}</div>
								<div class="d-flex-center f-20 c-white m-t-20">{{item.title1}}</div>
								<div class="d-flex-center w-30 h-7 bgc-EA4638 m-t-20"></div>
							</div>
							<div v-else class="fu2 c-white w-227 h-350 bgc-EA4638 p-t-20 p-l-25 p-r-25">
								<div class="f-20 c-white">{{item.title}}</div>
								<div class="d-flex-center w-30 h-7 bgc-white m-t-10"></div>
								<div class="f-14 lh-20 m-t-15">
									{{item.content}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="w-100p p-t-30 p-b-30 bgc-f4f4f4">
				<div class="f-20 c-00 font-weight-bold d-flex-center m-b-30">配套设施服务</div>
				<div v-for="(item,index) in otherinfo.support" :key="index" class="d-flex-center m-b-20">
					<div class="bgc-white w-90p shadow p-10 d-flex-row d-flex-items-center">
						<div class="w-40p m-r-10">
							<div class="d-flex-center">
								<img :src="item.smallimages" class="w-55 h-60" />
							</div>
							<div class="d-flex-center m-t-25 f-20 c-00 font-weight-bold">
								{{item.title}}
							</div>
						</div>
						<div class="w-60p lh-20 d-flex-items-center">
							{{item.maincontent}}
						</div>
					</div>
				</div>
			</div>

			<div class="w-100p bgimgi-2 p-t-30 p-b-30 c-white">
				<div class="f-30 font-weight-bold d-flex-center">发展前景</div>
				<div class="d-flex-center">
					<div class="bgc m-t-20 w-80p p-20">
						<div class="f-14 lh-22">
							{{otherinfo.prospect.maincontent}}
							<!-- 作为长春市第一个人才公寓项目，长春市人才公寓项目的意义深远，不仅减轻青年人才就业创业成本，实现长春市“吸引人才、留住人才”的目的，更是创新了城市资产经营模式，对放大国有资本功能以及加快国有企业转型升级具有重大的引领作用。 -->
						</div>
						<!-- <div class="f-14 lh-22 m-t-20">
							党的十九大报告中提出“加快建立多主体供给、多渠道保障、租购并举的住房制度，让全体人民住有所居”。在中央全新政策的指引下，在房地产行业的拐点契机，未来，长租公寓行业面临巨大的发展前景，项目今后将采取资本运作、引入混合经济等方式，进行自主开发建设或收购兼并房源，实现扩张，发挥优势，依托智慧化信息技术，提升市场份额，实现项目的做大、做强、做优。
						</div> -->
					</div>
				</div>
			</div>

			<div id="cond" class="w-100p p-t-20 p-b-30 c-white bgc-F4F4F4 c-00">
				<div class="f-20 font-weight-bold d-flex-center">{{otherinfo.condition.title}}</div>
				<div class="d-flex-center">
					<div class="f-14 c-00 m-b-20 lh-25 d-flex-center m-t-30 w-90p">
						{{otherinfo.condition.maincontent}}
						<!-- 按照《长春市人才公寓建设和使用管理办法》中的规定，入住长春市人才公寓需要符合有关审核标准和入住条件，经长春市人社部门审核通过后方可入住，具体条件如下： -->
					</div>
				</div>
				<div class="d-flex-center">
					<div class="p-20 d-flex-items-center f-14 lh-25 c-00 d-flex-center  w-90p bgc-white b-all">
						{{otherinfo.condition.maincontent2}}
						<!-- 《长春市人才公寓建设和使用管理办法》中规定长春市人才公寓的租赁对象为近3年内从长春市市区外引进到长春市市区企业工作且在市区无住房的高层次人才、产业发展急需紧缺人才，在企业新就业或自主创业的高校毕业生。引进人才除国内外顶尖人才和国家级领军人才外，至少与用人单位签订3年以上（含3年）劳动合同。 -->
					</div>
				</div>
				<div class="m-t-30">
					<div @mouseenter="enter(index)" @mouseleave="leave" v-for="(item,index) in otherinfo.personnel"
						:key="index" class="bgc-white b-all width-100-30 m-l-15 m-r-15" :class="index!=0?'m-t-20':''">
						<div class="b-b p-20">
							<div class="d-flex-row d-flex-items-center">
								<div class="b-all-EA4638-3 w-13 h-13 br-60 m-r-10"></div>
								<div class="f-18 c-00">{{item.title}}</div>
							</div>
							<div class="f-14 c-99 lh-30 m-t-15">
								{{item.content}}
							</div>
						</div>
						<div class="p-20">
							<div v-for="(citem,cindex) in item.son_data" :key="cindex" class="d-flex-between lh-40">
								<div class="f-14 c-33">{{citem.title}}</div>
								<div>
									<span class="f-14 c-EA4638">{{citem.content}}</span>
									<span class="f-14 c-66">平方米以上</span>
								</div>
							</div>
						</div>
						<div :class="cnav==index? 'w-100p h-6 bgc-EA4638':'h-6'"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		list,
		service,
		condition
	} from './config/index.js'
	import countTo from 'vue-count-to';
	import {
		Loading
	} from 'element-ui';
	export default {
		components: {
			countTo
		},
		data() {
			return {
				tab: ['关于我们', '入住条件'],
				nav: 0,
				list: list,
				lnav: -1,
				service: service,
				condition: condition,
				cnav: -1,
				info: {
					header_info: {}
				},
				areas: "",
				areae: "",
				otherinfo: {}
			}
		},
		mounted() {
			this.getinfo()
			this.getotherinfo()
			this.$nextTick(() => {
				new this.$wow.WOW().init();
			});
		},
		methods: {
			async getotherinfo() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});

				const res = await this.$service.get({
					url: '/api/web/v1/app_get_otherinfo'
				})
				if (res.code === 1) {
					this.otherinfo = res.info;
					this.$nextTick(() => {
						loading.close();
					}, 2000);
				}
			},
			async getinfo() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				const res = await this.$service.get({
					url: '/api/web/v1/app_get_headerinfo'
				})
				if (res.code === 1) {
					this.info = res.info;
					var area = res.info.header_info.area;
					this.areas = Number(area.split("~")[0]);
					this.areae = Number(area.split("~")[1]);
					this.advantage = res.info.advantage.map((res) => {
						return {
							content: res.content,
							smallimages: res.smallimages,
							title: res.title,
							title0: res.title.split("-")[0],
							title1: res.title.split("-")[1],
						}
					});
					this.$nextTick(() => {
						loading.close();
					}, 2000);
				}
			},
			choice1(index) {
				this.nav = index;
				if (index == 1) {
					document.querySelector("#cond").scrollIntoView();
				}
			},
			choice(index) {
				this.nav = index;
				if (index == 1) {
					document.querySelector("#condition").scrollIntoView();
				}
			},
			mouseenter(index) {
				this.lnav = index;
			},
			mouseleave() {
				this.lnav = -1;
			},
			enter(index) {
				this.cnav = index;
			},
			leave() {
				this.cnav = -1;
			}
		}
	}
</script>

<style scoped>
	.fu {
		position: relative;
		z-index: 2;
		margin-top: -350px;
	}

	.fufu {
		position: relative;
		z-index: 2;
		margin-top: -200px;
	}

	.fu1 {
		position: relative;
		z-index: 2;
		margin-top: -385px;
	}

	.fu2 {
		position: relative;
		z-index: 2;
		margin-top: -350px;
	}

	.shadow {
		box-shadow: 0px 0px 20px #ebebeb;
	}

	.bgimg {
		background: url('../../assets/image/about/bg.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.bgimgi-2 {
		background: url('../../assets/image/about/i-2.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.m-h-130 {
		min-height: 155px;
		max-height: 200px;
	}
</style>
